export default "__VITE_ASSET__$5pR1du8__"